<template>
  <!-- <v-app-bar app color="white" dark>
    <router-link to="/">
      <div class="d-flex align-center">

        <v-img
          alt="LSTN"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          :src="require('@/assets/logo.png')"
          width="100"
        />
      </div>
    </router-link>

    <v-spacer></v-spacer>
    <p v-if="user">{{user.email}}</p>
    <v-btn text color="primary" v-for="item in menuItems" :key="item.title" :to="item.link">
      <v-icon left dark>{{ item.icon }}</v-icon>
      {{ item.title }}
    </v-btn>
  </v-app-bar> -->
  <div>
      <v-app-bar app color="white">
        <v-app-bar-nav-icon
          class="hidden-md-and-up blackish--text"
          @click="drawer = !drawer"
        />

        <v-container class="mx-auto py-0">
          <v-row align="center">
            <router-link to="/">
              <v-img
                alt="LSTN"
                class="shrink mt-1 hidden-sm-and-down"
                contain
                min-width="100"
                :src="require('@/assets/logo.png')"
                width="100"
              />
            </router-link>
            
            

            <v-btn
              text color="primary"
              v-for="item in menuItems"
              :key="item.title"
              :to="item.link"
              class="hidden-sm-and-down" 
              active-class="v-btn--active">
              <v-icon left dark>{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-btn>

            <v-spacer />

            <DataRangeTypePicker />

            <DataPicker />
          </v-row>
        </v-container>
      </v-app-bar>

      <v-navigation-drawer
          v-model="drawer"
          style="position:fixed; top:0; left:0; overflow-y:scroll;"
          temporary
        >
          <v-list
            nav
          >
            <v-list-item-group
              active-class="primary--text text--accent-4" >
              <v-list-item v-for="item in menuItems" :key="item.title" :to="item.link">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
      </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NavBar",

  components: {
    DataPicker: () => import("@/components/misc/DataPicker"),
    DataRangeTypePicker: () => import("@/components/misc/DataRangeTypePicker"),
  },

  data: () => ({
    drawer: false,
  }),

  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
    }),
    menuItems() {
      let menuItems = [
        { icon: "mdi-account", title: "Sign in", link: "/login" },
      ];
      if (this.$store.getters.user) {
        menuItems = [
          { icon: "mdi-home", title: "Dashboard", link: "/" },
          { icon: "mdi-home", title: "Accounts", link: "/orgs" },
          { icon: "mdi-home", title: "Users", link: "/users" },
          { icon: "mdi-cog", title: "", link: "/settings" },
        ];
      }
      return menuItems;
    },
  },
};
</script>

<style></style>
